// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Icon from '../Icon';

import '../../helpers/base.less';
import './IconButton.less';

/**
 * `IconButton` component.
 */
const IconButton = ({ baseClassName, className, icon, ...props }) => (
    <button
        className={classNames(baseClassName, className)}
        type="button"
        {...props}
    >
        {Icon.create(icon)}
    </button>
);

IconButton.propTypes = {
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element,
    ]).isRequired,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

IconButton.defaultProps = {
    className: null,
    baseClassName: `${CLS_PREFIX}icon-button`,
};

export default IconButton;



// WEBPACK FOOTER //
// ./components/IconButton/IconButton.js